import {CSSProperties} from '../../../styleSheet';
import {BasePointerEventsProps} from '../types';

export const buildPointerEventsStyle = ({
  pointerEvents,
}: BasePointerEventsProps = {}): CSSProperties => {
  if (pointerEvents === 'none' || pointerEvents === 'auto') {
    return {
      pointerEvents,
    };
  }

  if (pointerEvents === 'box-none') {
    return {
      pointerEvents: 'none',
      '> *': {
        pointerEvents: 'auto',
      },
    };
  }

  return {};
};
